import axios from 'axios'
import type { ApiResponse, SearchRequest, SearchResponse } from '../types'

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5000'

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 10_000,
  headers: { 'Content-Type': 'application/json' },
})

export const searchApi = {
  /**
   * Full-text search across posts.
   */
  async search(request: SearchRequest): Promise<SearchResponse> {
    const { data } = await client.get<ApiResponse<SearchResponse>>('/api/search', { params: request })
    return data.data
  },

  /**
   * Suggest completions for the given query prefix.
   */
  async suggest(q: string): Promise<string[]> {
    const { data } = await client.get<string[]>('/api/search/suggest', { params: { q } })
    return data
  },
}
